// Mock data for Viral Strateji website
export const mockData = {
  company: {
    name: "Viral Strateji",
    tagline: "Dijital Dünyada İz Bırakan Çözümler",
    description: "Modern web siteleri ve blockchain teknolojileriyle markanızı geleceğe taşıyın.",
    contact: {
      email: "info@viralstrateji.com",
      website: "www.viralstrateji.com",
      location: "İstanbul, Türkiye"
    }
  },
  
  services: {
    website: {
      title: "Website & Teknoloji Hizmetleri",
      subtitle: "Modern, mobil uyumlu ve SEO dostu web siteleriyle markanızı dijitalde bir adım öne taşıyın.",
      items: [
        {
          id: 1,
          title: "Kurumsal Web Sitesi",
          description: "Profesyonel kurumsal kimliğinizi yansıtan modern web sitesi",
          price: "₺9.900'den başlayan",
          features: ["Responsive tasarım", "SEO optimizasyonu", "CMS yönetimi", "SSL sertifikası"]
        },
        {
          id: 2,
          title: "E-Ticaret Sitesi",
          description: "WooCommerce veya Flutter ile güçlü e-ticaret çözümleri",
          price: "₺11.900'den başlayan", 
          features: ["Ödeme entegrasyonu", "Stok yönetimi", "Mobil uygulama", "Analytics"]
        },
        {
          id: 3,
          title: "Kişisel Portfolyo",
          description: "Yaratıcı portfolyo siteleriyle kendinizi öne çıkarın",
          price: "₺7.900'den başlayan",
          features: ["Özel tasarım", "Galeri sistemi", "Blog entegrasyonu", "Sosyal medya"]
        },
        {
          id: 4,
          title: "Web3 Entegrasyonu",
          description: "Metamask bağlantısı ve token görüntüleme özellikleri",
          price: "Teklif Üzerine",
          features: ["Metamask bağlantısı", "Token görüntüleme", "NFT galerisi", "DApp geliştirme"]
        }
      ]
    },
    
    crypto: {
      title: "Kripto & Blockchain Hizmetleri",
      subtitle: "Projenizi blockchain dünyasında hayata geçirin. Güvenilir token üretimi ve akıllı sözleşme hizmetleri.",
      items: [
        {
          id: 1,
          title: "Token Kurulumu",
          description: "BEP20, ERC20 ve Polygon ağlarında token oluşturma",
          price: "₺4.900",
          features: ["Çoklu ağ desteği", "Güvenlik testleri", "Kontrat doğrulama", "Teknik dokümantasyon"]
        },
        {
          id: 2,
          title: "Akıllı Sözleşme",
          description: "Testnet doğrulaması ile güvenli akıllı sözleşmeler",
          price: "Hizmete Dahil",
          features: ["Testnet testi", "Güvenlik auditi", "Gas optimizasyonu", "Upgrade desteği"]
        },
        {
          id: 3,
          title: "Whitepaper Yazımı",
          description: "Profesyonel whitepaper tasarımı ve içerik yazımı",
          price: "₺450",
          features: ["İçerik yazımı", "Profesyonel tasarım", "PDF formatı", "Revizyon hakkı"]
        },
        {
          id: 4,
          title: "Kombinasyon Paketi",
          description: "Token + Website paketi özel fiyatlarla",
          price: "₺13.900'den başlayan",
          features: ["Token + Website", "Özel indirim", "Entegre çözüm", "Öncelikli destek"]
        }
      ]
    },
    
    design: {
      title: "Tasarım & Marka Geliştirme",
      subtitle: "İlk izlenim her şeydir. Markanızı profesyonel görünümle güçlendirin.",
      items: [
        {
          id: 1,
          title: "Logo Tasarımı",
          description: "Markanızı en iyi şekilde temsil eden logo tasarımları",
          price: "₺290'dan başlayan",
          features: ["3 konsept sunumu", "Sınırsız revizyon", "Tüm formatlar", "Marka rehberi"]
        },
        {
          id: 2,
          title: "Kurumsal Kimlik",
          description: "Bütüncül marka kimliği geliştirme hizmetleri",
          price: "₺490'dan başlayan", 
          features: ["Logo + kartvizit", "Antetli kağıt", "Marka renkleri", "Typography rehberi"]
        },
        {
          id: 3,
          title: "Whitepaper Tasarımı",
          description: "Etkileyici ve profesyonel whitepaper tasarımları",
          price: "₺450",
          features: ["Modern tasarım", "İnfografikler", "PDF optimizasyonu", "Baskıya hazır"]
        },
        {
          id: 4,
          title: "Broşür & Katalog",
          description: "Ürün katalogları ve tanıtım broşürleri",
          price: "₺490",
          features: ["Çok sayfalı tasarım", "Görsel düzenlemeler", "Baskı kalitesi", "Dijital versiyon"]
        }
      ]
    }
  },
  
  portfolio: [
    {
      id: 1,
      title: "TechCorp Kurumsal Sitesi",
      category: "Website",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop&crop=center",
      description: "Modern kurumsal web sitesi tasarımı"
    },
    {
      id: 2,
      title: "CryptoToken Projesi",
      category: "Blockchain",
      image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&h=600&fit=crop&crop=center",
      description: "BEP20 token geliştirme ve whitepaper"
    },
    {
      id: 3,
      title: "ArtStudio Logo",
      category: "Tasarım",
      image: "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&h=600&fit=crop&crop=center",
      description: "Sanat stüdyosu için logo ve kimlik tasarımı"
    },
    {
      id: 4,
      title: "E-Commerce Platform",
      category: "Website",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop&crop=center",
      description: "Modern e-ticaret sitesi geliştirme"
    },
    {
      id: 5,
      title: "NFT Marketplace",
      category: "Blockchain", 
      image: "https://images.unsplash.com/photo-1642104704074-907c0698cbd9?w=800&h=600&fit=crop&crop=center",
      description: "NFT pazaryeri smart contract geliştirme"
    },
    {
      id: 6,
      title: "Restaurant Branding",
      category: "Tasarım",
      image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop&crop=center",
      description: "Restoran için komple marka kimliği"
    }
  ],
  
  orderProcess: [
    {
      step: 1,
      title: "Form Doldurma",
      description: "Müşteri hangi hizmeti istediğini belirtir.",
      icon: "FileText"
    },
    {
      step: 2,
      title: "Teklif & Onay",
      description: "Belirlenen fiyat aralığında teklif hazırlanır.",
      icon: "CheckCircle"
    },
    {
      step: 3,
      title: "Ödeme",
      description: "Kripto veya banka transferi ile ödeme yapılır.",
      icon: "CreditCard"
    },
    {
      step: 4,
      title: "Üretim",
      description: "Tasarım → Kodlama → Test → Teslimat aşamaları.",
      icon: "Settings"
    },
    {
      step: 5,
      title: "Teslim & Destek",
      description: "30 gün ücretsiz destek sağlanır.",
      icon: "Headphones"
    }
  ],
  
  paymentMethods: [
    {
      type: "Kripto",
      methods: ["USDT", "BNB", "ETH", "MATIC"],
      icon: "Coins"
    },
    {
      type: "Banka",
      methods: ["Havale", "EFT"],
      icon: "Building"
    }
  ],
  
  faqs: [
    {
      question: "Neden sadece kripto ve havale kabul ediyorsunuz?",
      answer: "Kripto projeleri ve global yazılım hizmetleri verdiğimiz için işlemlerimizi en hızlı ve güvenli yollarla (USDT, BNB, Banka Havalesi) tamamlıyoruz. Bu durum, işlem maliyetlerini düşürerek size daha uygun fiyatlar sunmamızı sağlar."
    },
    {
      question: "Bir web sitesinin tamamlanması ne kadar sürer?",
      answer: "Projenin kapsamına göre kurumsal siteler 5-7 gün, e-ticaret siteleri ise 10-14 gün içerisinde anahtar teslim olarak sunulur."
    },
    {
      question: "Token kurulumundan sonra teknik destek veriyor musunuz?",
      answer: "Evet, tüm projelerimizde teslimat sonrası 30 gün boyunca ücretsiz teknik destek ve danışmanlık sağlıyoruz."
    },
    {
      question: "Kendi tasarımımı getirebilir miyim?",
      answer: "Elbette! Hazır tasarımlarınızı en güncel teknolojilerle (React, Next.js vb.) koda dökebilir veya mevcut tasarımlarınız üzerinde iyileştirmeler yapabiliriz."
    }
  ]
};

// API configuration
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Form submission using real API
export const submitContactForm = async (formData) => {
  try {
    // Telefon numarasına +90 ekle
    const formattedData = {
      ...formData,
      phone: `+90${formData.phone.replace(/\D/g, '')}` // Sadece rakamları al ve +90 ekle
    };

    const response = await fetch(`${API_BASE}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Form gönderilirken bir hata oluştu');
    }

    const result = await response.json();
    return { 
      success: true, 
      message: 'Mesajınız başarıyla gönderildi! En kısa sürede size geri dönüş yapacağız.',
      data: result
    };
  } catch (error) {
    console.error('Form submission error:', error);
    return { 
      success: false, 
      message: error.message || 'Form gönderilirken bir hata oluştu. Lütfen tekrar deneyin.'
    };
  }
};